import React, { useEffect, useState } from "react";
import ShowMoreTopics from "./popups/ShowMoreTopics";
import closeicon from "../../assets/img/community/x-circle.svg"
import ResponsePopup from "../../commonComponents/responseSucessPopup";

const TrendingTopics = (props) => {
  
  const [selectedTopics, setSelectedTopic] = useState([]);
  const [selectedTopicId, setSelectedTopicId] = useState([]);
  const [showmore, setShowMore] = useState(false);
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [isSucess, SetSucess] = useState(false);
  const [ResponseMessage, SetResponseMessage] = useState("");
  const currentPath = window.location.pathname; 
  
  useEffect(() => {
    setSelectedTopic([]);
    setSelectedTopicId([]);
 
   
  }, [props.communityId]);

  
  const showmoreTopic = () => {
    setShowMore(true);
  }
  const HideTopics = () => {
    setShowMore(false);
  }
  const showMoreTopics = () => {
    showmoreTopic();
  }
  const ClearAll = () => {
   
     setSelectedTopic([]);
    setSelectedTopicId([]);
    updateFeed([]);
   
  }
 
  const handleButtonClick =(topicTitle, topicId,abbr) => {
   
     if(selectedTopicId.includes(topicId)){
         removeTopic(topicId);
       
      }
      else{

      
   
      if (selectedTopics.length < 5) {
        const newTopic = { topicTitle: topicTitle, topicId: topicId,abbr:abbr };
        setSelectedTopic([...selectedTopics, newTopic]);
        const choosedTopicIds = [...selectedTopicId, topicId];
        setSelectedTopicId(choosedTopicIds);
         updateFeed(choosedTopicIds);
       
      } else {
        SetSucess(true);
        SetResponseMessage("You can only select up to 5 topics.");
      
      }

    //}
      }
  }
  const removeTopic = (topicid) => {
    const updatedTopics = selectedTopics.filter(topic => topic.topicId !== topicid);
    setSelectedTopic(updatedTopics);
    const updatedTopicIds = selectedTopicId.filter(id => id !== topicid);
    setSelectedTopicId(updatedTopicIds);
    updateFeed(updatedTopicIds);
   
  }
   const updateFeed = (topicIds) => {
    const listpayload = { 
      userid: userData._id, 
      communityid: localStorage.getItem('communityId'), 
      topics: topicIds, 
      offset: 0, 
      limit: 20 
    };
    localStorage.setItem('postpayload', JSON.stringify(listpayload));
    props.fetchAllFeeds(listpayload);
  };

  const getAbbreviation = (str) => {
     if (typeof str !== 'string') return '';
    const strLengthArr = str.split(" ");
    const maxLength =  strLengthArr.length;
  if (typeof str !== 'string') return '';

  return str
    .split(/\s+/) // Split by spaces (handles multiple spaces)
    .filter(word => word.length > 0) // Remove empty strings
    .reduce((abbr, word) => {
      if (abbr.length >= maxLength) return abbr;
      
      // Find first alphabetic character
      const firstLetter = word.match(/[a-zA-Z]/)?.[0] || '';
      return abbr + firstLetter.toUpperCase();
    }, '')
    .substring(0, maxLength); // Ensure maxLength
};

  
  return (
    <div>
      <div className="topics-main">
        <h4 className="trending-topics_tittle">Trending Topics</h4>
        <div className="trending-topics-wrapper">
          <button type="button" className={selectedTopicId.length === 0 ? "topicslist active" : "topicslist"} onClick={() => ClearAll()}> All</button>
          {props.Topics.map((topics) => (
            topics && (
              <button 
                type="button"  
                key={topics._id} 
                className={selectedTopicId.includes(topics._id) ? "topicslist active" : "topicslist"} 
                onClick={() => handleButtonClick(
                  topics.topicTitle, 
                  topics._id,
                  getAbbreviation(topics?.communityId?.communityName)
                )}
              > 
                {topics.topicTitle} {currentPath === "/justlikeme" && (<strong>({getAbbreviation(topics?.communityId?.communityName)})</strong>)}
              </button>
            )
          ))}
      


        </div>
        {props.moreTopics.length > 0 ? (

          <button className="show-more" onClick={() => showMoreTopics()}>show more</button>
        ) : null}



      </div>
      {
        selectedTopics.length >0  ?(
          <div className="current-filters">
        <h5 className="currentfilters">Current filters </h5>
        <div className="current-filter-wrapper">
          {
            selectedTopics.map((topics, index) => {
              return (

                <div className="currentfilter-itm" key={index}>{topics.topicTitle}{currentPath === "/justlikeme" &&(<strong>({topics.abbr})</strong>)}
                  {/* <i class="fa fa-close" ></i> */}
                   <img src={closeicon} onClick={() => removeTopic(topics.topicId)} className="x-close " />
                  </div>
              )

            })
          }
           </div>
          {selectedTopics.length > 0 ? (<button type="button" className="btn bttn-clear" onClick={() => ClearAll()}>Clear all</button>
          ) : (null)}

       
      </div>

        ):(null)
      }
      
      <ShowMoreTopics showPopup={showmore} HideTopics={HideTopics} Topics={props.moreTopics} selectedTopicId={selectedTopicId} selectedTopics={selectedTopics}
        addSelectedTopic={handleButtonClick} getAbbreviation={getAbbreviation}
      ></ShowMoreTopics>
      {isSucess && (<ResponsePopup
                isSucess={isSucess}
                CancelPopup={() => {
                    SetSucess(false);
                }}
                message={ResponseMessage}
            />)}
    </div>

  );
};
export default TrendingTopics;